import { useMutation } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';
import type { FileUploadResultDto } from '../types/integrationHub';

/**
 * POST /api/eraf/integration-hub/storage/files — 파일 업로드 (INTEGRATION_INVOKE)
 */
export function useFileUpload() {
  return useMutation<FileUploadResultDto, { code: string; message: string }, File>({
    mutationFn: (file) => integrationHubApi.uploadFile(file),
  });
}
